import { styled } from '@mui/material/styles';
import Colors from 'js/constants/colors';

const PreviousSalesLinkSpan = styled('span', {
    shouldForwardProp: (prop) => prop !== 'customStyles',
})(({ customStyles }) => ({
    color: Colors.PRIMARY.MAIN,
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
        color: Colors.PRIMARY.MAIN_HOVER,
        textDecoration: 'none',
    },
    ...customStyles,
}));

export default PreviousSalesLinkSpan;
